// ============================================
// OREILLER VÉGÉTAL — Custom JS
// ============================================

// Cart Drawer — fermer en cliquant sur l'overlay
document.addEventListener('DOMContentLoaded', () => {

  // Fermer le drawer en cliquant sur l'overlay
  document.addEventListener('click', (e) => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    if (e.target.classList.contains('cart-drawer__overlay')) {
      drawer.removeAttribute('open');
      document.documentElement.style.overflow = '';
    }
  });

});
